import React from 'react'
import { Input } from 'reactstrap'


export default class CoreSimpleTextbox extends React.Component {
	static defaultProps = {
		type: 'text',
		alignRight: false
	}

	componentDidMount() {
		if (this.props.value === null) {
			this.props.onChange({
				name: this.props.name,
				value: ''
			})
		}
	}

	render() {
		const objInput = {}

		if (this.props.alignRight === true) {
			objInput.style = {
				textAlign: 'right'
			}
		}

		return (
			<Input
				type={this.props.type}
				onChange={this.props.onChange}
				name={this.props.name}
				value={this.props.value || ''}
				maxLength={this.props.maxLength}
				{...objInput}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/_core/simpleTextbox.jsx